import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Menu, Table } from 'semantic-ui-react';
import { DataNotFound } from '../../../../components/DataNotFound';
import { postAsync } from '../../../../components/helper/axiosHelper';
import { downloadCSV } from '../../../../components/helper/downloadCSVHelper';
import ReactPaginate from 'react-paginate';
import moment from 'moment';
import LoadingAnimation from '../../../../components/LoadingAnimation';
import SearchFilters from '../../../../components/elements/SearchFilter';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { printTable } from '../../../../utils/tableExportUtils';
const GWAProjectApprovalList = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [apiData, setApiData] = useState([]);
  const [dateTo, setDateTo] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [isLoad, setIsLoad] = useState(false);
  const [order, setOrder] = useState(0);
  const [datanotfound, setDatanotfound] = useState(false);
  const [pageCount, setPageCount] = useState(1);
  const [next, setNext] = useState(1);
  const [pageOptions, setPageOptions] = useState({
    pageNo: 1,
    pageSize: 20,
  });

  const token = localStorage.getItem('token');
  const { t } = useTranslation();
  const navigate = useNavigate();

  const isLogin = () => {
    if (!token) {
      navigate('/managementLogin');
    }
  };

  useEffect(() => {
    localStorage.setItem('isHome', false);
    isLogin();
    GetGWAProjectApprovalFilterList();
  }, [order]);

  const SearchFilter = {
    epUserID: 0,
    dateFrom: moment(dateFrom).format('DD/MM/YYYY'),
    dateTo: moment(dateTo).format('DD/MM/YYYY'),
    order,
  };

  const GetGWAProjectApprovalFilterList = async () => {
    try {
      setIsLoad(true);
      const response = await postAsync(
        `GWAProject/GetGWAProjectApprovalFilterList/${pageOptions.pageNo}/${pageOptions.pageSize}`,
        SearchFilter,
      );
      setIsLoad(false);
      setApiData(response?.data);
      setPageCount(response.page);
      setNext(pageOptions.pageNo);

      if (response?.statusCode == 204) {
        setDatanotfound(true);
      }
    } catch (err) {
      console.log(err);
      toast.error(t('Something went wrong, Please try again!'));
    }
  };

  const changePage = async ({ selected }) => {
    const select = selected + 1;
    await postAsync('GWAProject/GetGWAProjectApprovalFilterList/' + select + '/' + pageOptions.pageSize, SearchFilter, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then((response) => {
        setApiData(response.data);
        setNext(selected + 1);
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  // Export xlsl file
  const handleOnExport = () => {
    const filteredData = apiData?.map((item, ii) => ({
      'S.No': ii + 1,
      'Project Name': isActive
          ? item.projectNameAR || item.projectNameEN
          : item.projectNameEN || item.projectNameAR,
      'Project Notes': item.projectNotes,
      Date: item.date,
      Time: item.timeNow,
      Status:
        item?.maProjectApproveID === 0
          ? t('Pending')
          : item?.maProjectApproveID === 1
            ? t('Approved')
            : item?.maProjectApproveID === 2
              ? t('Disapproved')
              : 'N/A',
    }));
    downloadCSV(filteredData, 'Good Will Ambassador Project List Approval');
  };

//   const handlePrint = (e) => {
//     e.preventDefault();
//      const printWindow = window.open('', '_blank');
//     const tableContainer = document.createElement('div');
//     tableContainer.className = 'tableData my-4';

//     // Create and add the heading
//     const heading = document.createElement('h1');
//     heading.className = 'font-bold text-center my-8 sm:text-2xl text-xl text-customgreen';
//     heading.innerText = `${t('Project Approval List')}`; // Replace with your desired heading text
//     tableContainer.appendChild(heading);

//     const table = document.createElement('table');
//     table.style.width = '100%';
//     table.innerHTML = `
//     <thead style="background-color: #2f855a; color: white;">

//       <tr>
//         <th style="padding: 5px; border: 1px solid #ddd;">#</th>
//         <th style="padding: 5px; border: 1px solid #ddd;">${t('Project Name')}</th>
//         <th style="padding: 5px; border: 1px solid #ddd;">${t(`Project Notes`)}</th>
//         <th style="padding: 5px; border: 1px solid #ddd;">${t(`Date`)}</th>
//         <th style="padding: 5px; border: 1px solid #ddd;">${t(`Time`)}</th>
//         <th style="padding: 5px; border: 1px solid #ddd;">${t(`Status`)}</th>

//       </tr>
//     </thead>
//     <tbody>
//       ${apiData
//         .map(
//           (data, index) => `
//             <tr style="background-color: ${index % 2 === 0 ? '#f9f9f9' : '#fff'}; border: 1px solid #ddd;">
//               <td style="padding: 5px; border: 1px solid #ddd;">${index + 1}</td>
//               <td style="padding: 5px; border: 1px solid #ddd;">${
//                 isActive ? data.projectNameAR || data.projectNameEN : data.projectNameEN || data.projectNameAR
//               }</td>
//               <td style="padding: 5px; border: 1px solid #ddd;">${data?.projectNotes}</td>
//               <td style="padding: 5px; border: 1px solid #ddd;">${data?.date}</td>
//               <td style="padding: 5px; border: 1px solid #ddd;">${data?.timeNow}</td>
//               <td style="padding: 5px; border: 1px solid #ddd;"> ${
//                 data.activeID == (0 || null)
//                   ? t('Pending')
//                   : data.activeID == 1
//                     ? t('Active')
//                     : data.activeID == 2
//                       ? t('InActive')
//                       : 'N/A'
//               }</td>

//             </tr>
//           `,
//         )
//         .join('')}
//     </tbody>
//   `;

//     tableContainer.appendChild(table);
//     document.body.appendChild(tableContainer);

//     // Add CSS to hide everything except the table when printing
//     const style = document.createElement('style');
//     style.textContent = `
//     @media print {

//       body * {
//         visibility: hidden;
//         height: 0;

//       }
//       .tableData, .tableData * {
//         visibility: visible;
//       }
//       .tableData {
//         position: absolute;
//         left: 0;
//         top: 0;
//         width: 100%;
//         height: auto;
//         overflow: visible;
//       }
//     }
//   `;
//     document.head.appendChild(style);
//  printWindow.document.write(printWindow);
//  printWindow.document.close();
//     // Trigger the print dialog
//     // window.print();

//     // Clean up by removing the table container and style from the DOM
//     document.body.removeChild(tableContainer);
//     document.head.removeChild(style);

//     return 'success';
//   };

//   const handlePrint = (e) => {
//     e.preventDefault();

//     const ROWS_PER_PAGE = 20;
//     const totalPages = Math.ceil(apiData.length / ROWS_PER_PAGE);

//     // Detect Arabic mode
//     const isArabic = isActive; // Tumhara jo variable hai Arabic ke liye (ya document.dir === 'rtl')

//     const printWindow = window.open('', '_blank');

//     let html = `
// <!DOCTYPE html>
// <html dir="${isArabic ? 'rtl' : 'ltr'}">
// <head>
//   <meta charset="utf-8">
//   <title>Project Approval List</title>
//   <style>
//     @page { size: A4 portrait; margin: 10mm 8mm; }
//     body { 
//       margin:0; padding:0; 
//       font-family: Arial, sans-serif; 
//       direction: ${isArabic ? 'rtl' : 'ltr'};
//       text-align: ${isArabic ? 'right' : 'left'};
//     }
    
//     .page { page-break-after: always; width: 100%; min-height: 277mm; }
//     .page:last-child { page-break-after: avoid; }

//     h1 {
//       text-align: center;
//       color: #2f855a;
//       font-size: 24px;
//       font-weight: bold;
//       margin: 0 0 15px 0;
//     }

//     table {
//       width: 100%;
    
//       border-collapse: collapse;
//       font-size: 12px;
//       table-layout: fixed;
//       ${isArabic ? 'direction: rtl;' : ''}
//     }

//     th, td {
//       padding: 9px 6px;
//       border: 1.5px solid #000;
//       text-align: ${isArabic ? 'right' : 'left'};
//       word-wrap: break-word;
//     }

//     th {
//       background-color: #2f855a !important;
//       color: white;
//       font-weight: bold;
//     }

//     tr:nth-child(even) { background-color: #f8fffb; }

//     /* Arabic mein columns reverse kar do */
//     ${
//       isArabic
//         ? `
//       table { transform: scaleX(-1); }
//       th, td { transform: scaleX(-1); }
//     `
//         : ''
//     }
//   </style>
// </head>
// <body>`;

//     for (let i = 0; i < totalPages; i++) {
//       const start = i * ROWS_PER_PAGE;
//       const end = Math.min(start + ROWS_PER_PAGE, apiData.length);
//       const pageData = apiData.slice(start, end);

//       html += `
//     <div class="page">
//       <h1>${t('Project Approval List')}${totalPages > 1 ? ` - ${t('Page')} ${i + 1}/${totalPages}` : ''}</h1>
      
//       <table>
//         <thead>
//           <tr>
//             ${
//               isArabic
//                 ? `
//                 <th>${t('Status')}</th>
//                 <th>${t('Time')}</th>
//                 <th>${t('Date')}</th>
//                 <th>${t('Project Notes')}</th>
//                 <th>${t('Project Name')}</th>
//                 <th>#</th>
//               `
//                 : `
//                 <th>#</th>
//                 <th>${t('Project Name')}</th>
//                 <th>${t('Project Notes')}</th>
//                 <th>${t('Date')}</th>
//                 <th>${t('Time')}</th>
//                 <th>${t('Status')}</th>
//               `
//             }
//           </tr>
//         </thead>
//         <tbody>`;

//       pageData.forEach((item, index) => {
//         const srNo = start + index + 1;
//         const projectName = isActive
//           ? item.projectNameAR || item.projectNameEN
//           : item.projectNameEN || item.projectNameAR;

//         if (isArabic) {
//           html += `
//           <tr>
//             <td style="text-align:center; font-weight:600;">${
//               item.activeID == 0 || item.activeID == null
//                 ? t('Pending')
//                 : item.activeID == 1
//                   ? t('Active')
//                   : t('InActive')
//             }</td>
//             <td>${item.timeNow || ''}</td>
//             <td>${item.date || ''}</td>
//             <td>${item.projectNotes || ''}</td>
//             <td>${projectName}</td>
//             <td style="text-align:center; font-weight:600;">${srNo}</td>
//           </tr>`;
//         } else {
//           html += `
//           <tr>
//             <td style="text-align:center; font-weight:600;">${srNo}</td>
//             <td>${projectName}</td>
//             <td>${item.projectNotes || ''}</td>
//             <td>${item.date || ''}</td>
//             <td>${item.timeNow || ''}</td>
//             <td style="font-weight:600;">
//               ${
//                 item.activeID == 0 || item.activeID == null
//                   ? t('Pending')
//                   : item.activeID == 1
//                     ? t('Active')
//                     : t('InActive')
//               }
//             </td>
//           </tr>`;
//         }
//       });

//       html += `</tbody></table>
//       ${
//         totalPages > 1
//           ? `<div style="text-align:center; margin-top:10px; font-size:11px; color:#555;">
//         ${t('Page')} ${i + 1} ${t('of')} ${totalPages}
//       </div>`
//           : ''
//       }
//     </div>`;
//     }

//     html += `
//   <script>
//     window.onload = () => setTimeout(() => window.print(), 600);
//   </script>
// </body>
// </html>`;

//     printWindow.document.write(html);
//     printWindow.document.close();
//   };
const handlePrint = (e) => {
  e.preventDefault();
  
  // Column configuration
  const columns = [
    {
      header: t('sNo'),
      accessor: (row, index) => index + 1
    },
    {
      header: t('Project Name'),
accessor: (row) => isActive ? row?.projectNameAR || row?.projectNameEN || 'N/A' : row?.projectNameEN || row?.projectNameAR || 'N/A'
    },
     {
      header: t('Project Notes'),
      accessor: (row) => isActive ? row?.projectNotes : row?.projectNotes
    },   {
      header: t('Date'),
      accessor: (row) => isActive ? row?.date  || 'N/A' : row?.date  || 'N/A'
    },   {
      header: t('Time'),
      accessor: (row) => isActive ? row?.timeNow  || 'N/A' : row?.timeNow || 'N/A'
    },
 {
    header: t('Status'),
    accessor: (row) =>
      row.activeID == null || row.activeID === 0
        ? t('Pending')
        : row.activeID === 1
          ? t('Active')
          : t('InActive')
  }


  ];
  
  // Call the reusable print function
  printTable({
    data: apiData || [],
    isRTL: isActive, // isActive true = Arabic = RTL
    t: t,
    title: `${t('Project Approval List')} `,
    columns: columns,
    onBeforePrint: () => {
      console.log('Printing started...');
      // toast.info(t('Preparing print preview...'));
    },
    onAfterPrint: () => {
      console.log('Printing completed');
    },
    styles: {
      customCSS: `
        /* Additional custom styles if needed */
        .print-table th {
          font-weight: 600;
        }
        @media print {
          .print-title {
            color: #000 !important;
          }
        }
      `
    }
  });
};
  return (
    <>
      {!isLogin ? (
        <h1>{t('Not Authorized')}</h1>
      ) : (
        <>
          <div className="container-fluid ">
            {/* <div className="row justify-center">
              <div className="col-lg-11 text-center">
                <h3 className="font-bold sm:text-2xl  text-xl text-customgreen">
                  {t('Project Approval')} {t('list')}
                </h3>
              </div>
            </div> */}
            <div className="row justify-center py-5 mt-3">
              <SearchFilters
                handleSearch={GetGWAProjectApprovalFilterList}
                setDateFrom={setDateFrom}
                setDateTo={setDateTo}
                dateTo={dateTo}
                dateFrom={dateFrom}
                handlePrint={handlePrint}
                handleOnExport={handleOnExport}
                heading={'Project Approval List'}
              />
              <div className="col-lg-11 text-center pt-9">
                {isLoad ? (
                  <LoadingAnimation />
                ) : (
                  <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                    <Table className="text-sm tableData text-left rtl:text-right ">
                      <Table.Header className="font-bold text-white bg-customgreen uppercase ">
                        <Table.Row className="whitespace-nowrap">
                          <Table.HeaderCell className="text-white items-center align-middle">
                            {t('sNo')}
                          </Table.HeaderCell>
                          <Table.HeaderCell className="text-white  items-center align-middle">
                            {t('Project Name')}
                          </Table.HeaderCell>
                          <Table.HeaderCell className="text-white items-center align-middle">
                            {t('Project Notes')}
                          </Table.HeaderCell>
                          <Table.HeaderCell
                            className="text-white items-center align-middle"
                            onClick={() => {
                              setOrder(order == 0 ? 1 : 0);
                            }}
                            style={{ cursor: 'pointer' }}
                          >
                            {t('Date')}
                            {order ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />} {/* Add arrow indicator */}
                          </Table.HeaderCell>
                          <Table.HeaderCell className="text-white items-center align-middle">
                            {t('Time')}
                          </Table.HeaderCell>
                          <Table.HeaderCell className="text-white items-center align-middle">
                            {t('Status')}
                          </Table.HeaderCell>
                          <Table.HeaderCell className="text-white items-center align-middle">
                            {t('View')}
                          </Table.HeaderCell>
                        </Table.Row>
                      </Table.Header>

                      <Table.Body>
                        {apiData?.map((data, index) => {
                          const sno = (next - 1) * pageOptions.pageSize + index + 1;

                          return (
                            <Table.Row key={index}>
                              <Table.Cell>{sno}</Table.Cell>
                              <Table.Cell>
                                {isActive ? data?.projectNameAR || 'N/A' : data.projectNameAR || 'N/A'}
                              </Table.Cell>
                              <Table.Cell>{data.projectNotes}</Table.Cell>
                              <Table.Cell>{data.date}</Table.Cell>
                              <Table.Cell>{data.timeNow}</Table.Cell>
                              <Table.Cell>
                                {t(
                                  `${
                                    data.activeID == (0 || null)
                                      ? 'Pending'
                                      : data.activeID == 1
                                        ? 'Active'
                                        : data.activeID == 2
                                          ? 'InActive'
                                          : 'N/A'
                                  }`,
                                )}
                              </Table.Cell>
                              <Table.Cell>
                                <Link to={`/GWAProjectApproval/${data.gwaProjectID}`}>
                                  <button className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-4 py-2 text-center">
                                    {t('Detail')}
                                  </button>
                                </Link>
                              </Table.Cell>
                            </Table.Row>
                          );
                        })}
                      </Table.Body>
                    </Table>
                    {datanotfound && <DataNotFound />}
                  </div>
                )}
                {pageCount > 0 && (
                  <div className="flex flex-row px-12 justify-between">
                    <Menu pagination>
                      <Menu.Item>
                        <ReactPaginate
                          previousLabel={t('Previous')}
                          nextLabel={t('Next')}
                          pageCount={pageCount}
                          onPageChange={changePage}
                          containerClassName={'paginationButtons'}
                          previousLinkClassName={'previousButton'}
                          nextLinkClassName={'nextButton'}
                          disabledClassName={'paginationDisabled'}
                          activeClassName={'paginationActive'}
                        />
                      </Menu.Item>
                    </Menu>
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default GWAProjectApprovalList;
